import { Component } from 'react';
import { connect } from 'react-redux';

import { ArrowsHorizontalIcon, Button, Heading, ImportIcon, Pane, SelectField, TextInput, TrashIcon } from 'evergreen-ui';
import { Link } from 'react-router-dom';
import Request from "../../../util/Api";
import { getCategories } from '../../categories/actions/CategoryActions';
import { activateProduct, deactivateProduct, getProducts } from '../actions/ProductActions';
import MaintenanceModal from '../components/MaintenanceModal';
import ProductCard from '../components/ProductCard';



let searchTimeout = null;

class ListProducts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            maintenanceModal: false,
            importModal: false,
            page: 0,
            pages: 0,
            count: 0,
            search: localStorage.getItem('product-listing-search') || '',
            status: localStorage.getItem('product-listing-status') || '',
            availability: localStorage.getItem('product-listing-availability') || '',
            sort: 'id',
            direction: 'desc',
            outstandingTransfer: false,
            outstandingQuantities: [],
            editMode: false
        }

        this.showMaintenanceModal = this.showMaintenanceModal.bind(this);
        this.hideMaintenanceModal = this.hideMaintenanceModal.bind(this);
        this.setPage = this.setPage.bind(this);

        this.activateProduct = this.activateProduct.bind(this);
        this.deactivateProduct = this.deactivateProduct.bind(this);
        this.getOutstandingTransfer = this.getOutstandingTransfer.bind(this);
        this.clearFilters = this.clearFilters.bind(this);

        this.productsPerPage = 30;
    }

    setPage(page) {
        this.setState({
            page
        }, () => {
            this.handleTableChange({
                page
            });
        });
    }

    componentDidMount() {
        this.handleTableChange({});
        this.getOutstandingTransfer();
    }

    async getOutstandingTransfer() {
        const transfer = await Request.get(`/inventory/outstanding-transfer`);

        this.setState({
            outstandingTransfer: transfer.existing ? transfer.existing.id : false
        });


        if(transfer.existing && transfer.existing.items) {
            const productItems = transfer.existing.items;
            const outstandingQuantities =  productItems.map(item => ({
                productId: item.productId,
                quantity: item.quantity,
                stockAccountId: item.stockAccountId
            })) || [];

            this.setState({
                outstandingQuantities
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.products.count !== this.state.count) {
            this.setState({
                count: this.props.products.count,
                pages: Math.ceil(this.props.products.count / this.productsPerPage)
            })
        }
    }

    handleTableChange = (opts) => {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
            opts.start = opts.start || (this.state.page) * this.productsPerPage;
            opts.limit = opts.limit || this.productsPerPage;
            opts.sort = opts.sort || this.state.sort;
            opts.direction = opts.direction || this.state.direction;
            opts.search = opts.search || this.state.search;

            this.setState({
                sort: opts.sort || 'id',
                direction: opts.direction || 'id',
                //search: opts.search || this.state.search
            });

            if(typeof opts.categoryId !== "string") {
                opts.categoryId = localStorage.getItem('product-listing-category')
            }

            if(typeof opts.status !== "string") {
                opts.status = localStorage.getItem('product-listing-status') || '';
            }

            if(typeof opts.availability !== "string") {
                opts.availability = localStorage.getItem('product-listing-availability') || '';
            }

            if(opts.search) {
                localStorage.setItem('product-listing-search', opts.search);
            }

            if(typeof opts.categoryId === "string") {
                localStorage.setItem('product-listing-category', opts.categoryId);
            }

            if(typeof opts.status === "string") {
                localStorage.setItem('product-listing-status', opts.status);
            }

            if(typeof opts.availability === "string") {
                localStorage.setItem('product-listing-availability', opts.availability);
            }

            if(opts.page) {
                localStorage.setItem('product-listing-page', opts.page);
            }

            this.props.dispatch(getProducts(opts, {categoryId: opts.categoryId, status: opts.status || undefined, availability: opts.availability || undefined}));
            this.props.dispatch(getCategories());
        }, 400)

    }

    activateProduct(productId) {
        this.props.dispatch(activateProduct(productId));
    }

    deactivateProduct(productId) {
        this.props.dispatch(deactivateProduct(productId));
    }

    showMaintenanceModal() {
        this.setState({
            maintenanceModal: true
        })
    }

    hideMaintenanceModal() {
        this.setState({
            maintenanceModal: false
        })
    }

    clearFilters() {
        localStorage.removeItem('product-listing-search');
        localStorage.removeItem('product-listing-category');
        localStorage.removeItem('product-listing-status');
        localStorage.removeItem('product-listing-availability');
        localStorage.removeItem('product-listing-page');
        this.setState({
            search: '',
            status: '',
            availability: '',
            page: 0
        }, () => {
            this.handleTableChange({ search: '', categoryId: '', status: '', availability: '', page: 0 });
        });
    }


    render() {
        let category = localStorage.getItem('product-listing-category');
        let status = localStorage.getItem('product-listing-status') || '';
        let availability = localStorage.getItem('product-listing-availability') || '';

        return (<>
            <MaintenanceModal
                open={this.state.maintenanceModal}
                onClose={this.hideMaintenanceModal}
            />

            <Pane borderBottom="2px solid #eeeeee" marginBottom={10}>
                <Heading size={800}>Management Produse ({this.state.count} produse gasite)</Heading>
            </Pane>

            <Pane>
                <Link to="/products/create">
                    <Button iconBefore="add" intent="none" appearance="primary">
                        Produs nou
                    </Button>
                </Link>

                <Button iconBefore="build" type="button" margin={5} onClick={this.showMaintenanceModal} intent="warning" appearance="secondary">
                    Mentenanta Produse
                </Button>

                <Link to ="/products/import">
                    <Button type="button" margin={5} intent="success" appearance="primary">
                        <ImportIcon marginRight={5}/> Import Produse
                    </Button>
                </Link>

                {this.state.outstandingTransfer &&
                <Link to={`/stock-operations/${this.state.outstandingTransfer}`}>
                    <Button type="button" margin={5} intent="danger" appearance="default">
                        <ArrowsHorizontalIcon marginRight={5}/> NIR Transfer Activ
                    </Button>
                </Link>}

                <Button type="button" margin={5} intent={this.state.editMode ? "danger" : "none"} appearance="primary" onClick={() => this.setState({editMode: !this.state.editMode})}>
                    {this.state.editMode ? "Edit Mode" : "View Mode"}
                </Button>

            </Pane>
            <Pane display="flex" marginBottom={16}>
                <TextInput
                    marginTop={5}
                    marginRight={10}
                    placeholder="Cautare"
                    value={this.state.search}
                    onChange={(e) => {
                            this.setState({search: e.target.value}, () => {
                            this.handleTableChange({search: this.state.search})
                        })}
                    }
                />

                <SelectField

                        onChange={(e) => {
                            this.handleTableChange({categoryId: e.target.value});
                        }}
                    >
                        <option value="">Toate categoriile</option>
                        {this.props.categories.flatData.map(cat => (
                            <option key={cat.id} value={cat.categoryHierarchyId} selected={cat.categoryHierarchyId === category}>Categorie - {cat.label}</option>
                        ))}
                </SelectField>
                <SelectField
                    marginLeft={10}
                    value={status}
                    onChange={(e) => {
                        this.handleTableChange({status: e.target.value});
                    }}
                >
                    <option value="">Toate statusurile</option>
                    <option value="draft">Draft</option>
                    <option value="published">Publicat</option>
                    <option value="archived">Arhivat</option>
                </SelectField>
                <SelectField
                    marginLeft={10}
                    value={availability}
                    onChange={(e) => {
                        this.handleTableChange({availability: e.target.value});
                    }}
                >
                    <option value="">Toate disponibilitatile</option>
                    <option value="preorder">Doar precomenzi</option>
                </SelectField>
                <SelectField
                    marginLeft={10}
                    onChange={(e) => {
                        this.handleTableChange({sort: e.target.value.split("-")[0], direction: e.target.value.split("-")[1]})
                    }}>
                    <option value="id-asc">Id ASC</option>
                    <option value="id-desc">Id DESC</option>
                    <option value="lastStockEntry-desc">Ultimele intrate in stoc</option>
                    <option value="price-asc">Pret ASC</option>
                    <option value="price-desc">Pret DESC</option>
                    <option value="quantity-asc">Stocuri ASC</option>
                    <option value="quantity-desc">Stocuri DESC</option>
                    <option value="views-desc">Vizualizari DESC</option>
                    <option value="score-desc">Scor DESC</option>
                </SelectField>
                <Button
                    marginLeft={10}
                    marginTop={5}
                    intent="danger"
                    appearance="default"
                    onClick={this.clearFilters}
                >
                    <TrashIcon marginRight={5}/> Sterge Filtre
                </Button>
            </Pane>
            <Pane display="grid" gridTemplateColumns="repeat(auto-fit, minmax(300px, 1fr))">
                {this.props.products.data.map(product =>
                <ProductCard
                    editMode={this.state.editMode}
                    onUpdate={this.getOutstandingTransfer}
                    outstandingQuantities={this.state.outstandingQuantities.filter(qty => qty.productId == product.id) || []}
                    stockAccounts={this.props.stockAccounts.data}
                    toggleProduct={product.activeOnline ? () => this.deactivateProduct(product.id) : () =>  this.activateProduct(product.id)} product={product} />)}
            </Pane>
            <Pane display="flex" justifyContent="center" flexWrap="wrap">
                {[...Array(this.state.pages).keys()].map(page => <Button onClick={() => this.setPage(page)} appearance={page === this.state.page ? "primary": "default"} marginRight={10} marginBottom={10}>{page + 1}</Button>)}
            </Pane>
        </>)
    }
}

function mapStateToProps(state) {
    return {products: state.products, categories: state.categories, stockAccounts: state.stockAccounts};
}

export default connect(mapStateToProps)(ListProducts);
